import { Documentation } from '@/views/docs';

export default {
    path: '/docs',
    component: Documentation,
    children: [
        { path: ':docId', component: Documentation },
    ]
};

